import { CircularLoader } from '@sanlam-glacier/app-common/components';
import styles from './loading-page.module.scss';

export const LoadingPage = () => {
  return (
    <div className={styles.pageCircularLoaderContainer}>
      <div className={styles.pageCircularLoader}>
        <CircularLoader thickness={3} />
      </div>
    </div>
  );
};
